import { useNavigate } from "react-router-dom";
import { MapPinIcon, CalendarIcon, UserIcon } from "@heroicons/react/24/outline";
import { useState, useEffect } from "react";
import axios from "axios";

export default function SearchBar() {
    const [form, setForm] = useState({
        destination: "",
        checkIn: "",
        checkOut: "",
        guests: 1,
    });

    const navigate = useNavigate();
    const [destinations, setDestinations] = useState([]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!form.destination.trim()) {
            alert("Please enter the destination");
            return;
        }

        navigate("/search-hotels", { state: form });
    };

    useEffect(() => {
        axios.get("http://127.0.0.1:8000/api/destinations")
            .then((res) => {
                setDestinations(res.data);
            })
            .catch((err) => console.log(err));
    }, []);

    return (
        <div className="bg-white/10 backdrop-blur-lg border border-white/20 shadow-lg rounded-3xl p-6 lg:p-8 text-white">

            <h2 className="text-white !text-white text-2xl font-bold mb-3">
                Book Your Stay
            </h2>

            <p className="text-white/80 mb-6">
                Compare prices and find the best hotel deals in Dubai.
            </p>

            <form
                onSubmit={handleSubmit}
                className="grid grid-cols-1 md:grid-cols-2 gap-4"
            >

                {/* Destination */}
                <div className="md:col-span-2">
                    <label className="mb-2 block font-medium">
                        Destination
                    </label>

                    <div className="relative flex items-center">
                        <MapPinIcon className="w-5 h-5 absolute left-3 text-[#FF6B35] pointer-events-none" />

                        <select
                            name="destination"
                            value={form.destination}
                            onChange={handleChange}
                            className="w-full h-12 pl-10 pr-4 bg-white/90 text-gray-900 border border-white/30 rounded-xl focus:ring-2 focus:ring-[#FF6B35] focus:outline-none"
                        >
                            <option value="">Select Destination</option>
                            {destinations.map((dest) => (
                                <option key={dest.id} value={dest.name}>
                                    {dest.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Check-in */}
                <div>
                    <label className="text-white mb-2 block font-medium">
                        Check In
                    </label>

                    <div className="relative">


                        <input
                            type="date"
                            name="checkIn"
                            value={form.checkIn}
                            onChange={handleChange}
                            className="w-full h-12 px-4 bg-white/90 text-gray-900 border border-white/30 rounded-xl focus:ring-2 focus:ring-orange-400 focus:outline-none"
                        />
                    </div>
                </div>

                {/* Check-out */}
                <div>
                    <label className="text-white mb-2 block font-medium">
                        Check Out
                    </label>

                    <div className="relative">


                        <input
                            type="date"
                            name="checkOut"
                            value={form.checkOut}
                            onChange={handleChange}
                            className="w-full h-12 px-4 bg-white/90 text-gray-900 border border-white/30 rounded-xl focus:ring-2 focus:ring-orange-400 focus:outline-none"
                        />
                    </div>
                </div>

                {/* Guests */}
                <div className="md:col-span-2">
                    <label className="text-white mb-2 block font-medium">
                        Guests
                    </label>

                    <div className="relative flex items-center">
                        <UserIcon className="w-5 h-5 absolute left-3 text-[#FF6B35] pointer-events-none" />

                        <select
                            name="guests"
                            value={form.guests}
                            onChange={handleChange}
                            className="w-full h-12 pl-10 pr-4 bg-white/90 text-gray-900 border border-white/30 rounded-xl focus:ring-2 focus:ring-[#FF6B35] focus:outline-none"
                        >
                            {[1, 2, 3, 4, 5, 6].map((num) => (
                                <option key={num} value={num}>
                                    {num}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Button */}
                <div className="md:col-span-2">
                    <button
                        type="submit"
                        className="w-full h-14 bg-[#FF6B35] hover:bg-orange-600 text-white font-semibold rounded-xl transition-all duration-300"
                    >
                        Search Hotels
                    </button>
                </div>

            </form>
        </div>
    );
}